import { Button } from "antd";
import React from "react";

const CustomButtonWithIcon = ({
  title = "",
  icon = "",
  onClick,
  bgColor = "transparent",
  showBorder = true,
  borderColor = "#20C3FF",
  width = 160,
  isFirst = false,
  color = "#20C3FF",
  fontSize = 16,
  disabled = false,
  isRound = false,
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      style={{
        backgroundColor: bgColor,
        height: 43,
        borderRadius: isRound ? 8 : 5,
        minWidth: width,
        color: color,

        fontSize: fontSize,
        fontFamily: "Poppins-Regular",
        border: showBorder
          ? `1px solid  ${borderColor ? borderColor : "#20C3FF"}`
          : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8, // Spacing between icon and title
      }}
    >
      {icon && !isFirst && <img src={icon} />}
      {title}
      {icon && isFirst ? <img src={icon} /> : null}
    </Button>
  );
};

export default CustomButtonWithIcon;
